import moment from 'moment';

const Time = {

    getMealTime() {
        let format = "hh:mm A";
        let currentTime = moment(moment().format(format), format);
        let beforeTime = moment('08:00 AM', format);
        let afterTime = moment('2:00 PM', format);

        if (currentTime.isBetween(beforeTime, afterTime)) {
            return 'Lunch';
        } else {
            return 'Dinner';
        }
    }
}


export default Time;